import React, { Component } from 'react';

class TeamLogo extends Component {
  render() {
    if(this.props.teamFilter !== null){
      return (
        <div>
          <div className="section-title">Team</div>
          <div className="teamLogoContainer">
            <div className="teamLogoBox">
              <img className="team-logo" src={"https://www.roadtonationals.com/results/imgs/logos/men/"+this.props.teamFilter+"_logo.png"} alt="logo" />
            </div>
          </div>
        </div>
      );
    }
  }
}

export default TeamLogo;
